import Cross from 'components/icons/Cross';

export default ({ children }) => (
  <div className="flex items-center">
    <Cross size={13} />
    <div className="ml-3">{children}</div>
  </div>
);
